import APP_ACTIONS from '../constants/app-actions';
import StoreAPI from '../apis/store';
import localStorageAPI from '../services/local-storage-api';

const Stores = {
    loadStores: () => (dispatch, getState) => StoreAPI.getStores().then((response) => {
        dispatch({ type: APP_ACTIONS.ADD_STORES, payload: response.body });
        localStorageAPI.save(getState());
        return response.body;
    }),
    loadGroupedStores: () => (dispatch, getState) => StoreAPI.getGroupedStores().then((response) => {
        dispatch({ type: APP_ACTIONS.ADD_STORES_GROUPED, payload: response.body });
        localStorageAPI.save(getState());
        return response.body;
    }),
    setCurrentStore: (store) => (dispatch, getState) => {
        dispatch({ type: APP_ACTIONS.SET_CURRENT_STORE, payload: store });
        localStorageAPI.save(getState());
        return store;
    },
    loadStorePayments: (store) => (dispatch, getState) => StoreAPI.getStorePayments(store.id).then((response) => {
        dispatch({ type: APP_ACTIONS.SET_CURRENT_STORE, payload: { ...store, payments: [...response.body] } });

        localStorageAPI.save(getState());
        return response.body;
    }),
    getStoresByZone: (zoneId, page, limit) => (dispatch, getState) => StoreAPI.getStoresByZone(zoneId, page, limit).then((response) => {
        dispatch({ type: APP_ACTIONS.ADD_STORES_BY_ZONE, payload: { storesByZone: response.body.data, pageCount: response.body.pagination.total_pages } });
        localStorageAPI.save(getState());
        return response.body;
    }),
};

export default Stores;



/** WEBPACK FOOTER **
 ** ./src/actions/stores.js
 **/